export default {
    version: 'v5'
};
